<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window copy-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="t-copy"></div>

                <div class="msg-view">
                    <p>{{ shareTxt }}</p>
                </div>

                <div class="u-btn copy"  @click="copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt"></div>
            </div>       
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            iscopy : false,
            text : '请稍后……',
            shareTxt : '分享专属链接 开启助力',
            gid : '',
            mode : 1,
            ajax_error : false,           
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              //_this.$error_modal({text : "复制成功"});
              _this.$toast("复制成功");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
              //_this.$error_modal({text : "复制失败"});
            });
        },             
    },
}
</script>

<style lang="scss" scoped>
    .dialog-view{
        z-index: 100;
    }

    .copy-modal{
        position: relative;
        width: 656px;
        height: 337px;
        background-image: url(~@/assets/images/modal/bg-modal-sm.png);        
    }

    .t-copy{
        width: 465px;
        height: 42px;
        margin: 0 auto 16px;
        background-image: url(~@/assets/images/modal/title-copy.png);      
    }


    .msg-view{
        line-height: 1.6;
        padding: 0 54px;
        font-size: 20px;

        color: #696560;
    }

    .u-btn.copy{
        position: absolute;
        left: 50%;
        bottom: 34px;
        transform: translateX(-50%);
        width: 267px;
        height: 62px;
        background-image: url(~@/assets/images/modal/btn-copy.png);

    }         
    
</style>